// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Slabo 27px', 'Slabo 27px Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_e4ec31"};